/*!
 * Manera Athletes
 * 
 */
$(document).ready(function(){

    if($('#socialStop ').length > 0) {
        //position du STOP scrolling social
        var stop = $('#socialStop');
        var ppos = stop.offset();
        //var ph = products.height();

        var social = $('.athlete__interview').find('.social');

        var currentPos = $('.athlete__interview').offset();

        var delta = ppos.top - currentPos.top;


        var athController = new ScrollMagic.Controller();
        var athScene = new ScrollMagic.Scene({
            triggerElement: social,
            duration: delta + social.height()+140
        }).setPin(social).addTo(athController);
    }
    if(window.matchMedia("(max-width:991.98px)").matches){

        if($('.portrait').length > 0) {
            var picture = $('.portrait').find('.image_container');
            var socialPos = picture.position().top + picture.height();
            $('.athlete__socials').css('top', socialPos + 50);
        }
    }
});